/**
 * 公告中心
 */

import {
    get,
    post,
    put,
    del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectNoticeById = (Id) => {
    return get('/api/app/Notice?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddNotice = (data) => {
    return post('/api/app/Notice', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyNotice = (data) => {
    return put('/api/app/Notice', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataNoticeList = (data) => {
    return post('/api/app/Notice/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteNotice = (id) => {
    return del('/api/app/Notice/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
export const ExportInjuryUnit = (data) => {
    let defaluturl = `/api/app/Notice/exportExcelFile`;
    let fileName = "公告中心"
    return download(fileName, defaluturl, data);
}